import { useEffect, useRef, useState } from 'react'
import { useStore } from '../state/store'
import { addBrand } from '../lib/api'
import { I } from './Icons'
import { Sheet } from './Sheet'

/** Pick a brand from the list or add one. Keeps vendor names consistent in Shopify (no more "Chrome hearts" vs "Chrome Hearts"). */
export function BrandSheet({ value, onPick, onClose }: { value: string; onPick: (b: string) => void; onClose: () => void }) {
  const { brands, refresh } = useStore()
  const [q, setQ] = useState('')
  const [busy, setBusy] = useState(false)
  const ref = useRef<HTMLInputElement>(null)
  useEffect(() => { ref.current?.focus() }, [])
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => { if (e.key === 'Escape') onClose() }
    window.addEventListener('keydown', onKey); return () => window.removeEventListener('keydown', onKey)
  }, [onClose])
  const t = q.trim()
  const list = brands.filter((b) => !t || b.toLowerCase().includes(t.toLowerCase()))
  const exact = brands.find((b) => b.toLowerCase() === t.toLowerCase() || (t.length < 4 && b.toLowerCase().startsWith(t.toLowerCase())))
  const add = async () => {
    setBusy(true)
    try { await addBrand(t, null); await refresh(); onPick(t) } finally { setBusy(false) }
  }
  return (
    <Sheet onClose={onClose} center picker label="Pick a brand">
        <div className="sheet__title">Brand</div>
        <div className="search" style={{ background: 'var(--page)' }}>{I.search()}<input ref={ref} value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search or type a new brand" /></div>
        <div className="picker-list">
          {list.map((b) => (
            <button key={b} type="button" className={'row row--nav' + (b === value ? ' picker-sel' : '')} onClick={() => onPick(b)}><span className="row__label">{b}</span>{b === value && <span className="row__value set">✓</span>}</button>
          ))}
          {list.length === 0 && <div className="empty">No brand called “{t}” yet.</div>}
        </div>
        {t && !exact && <button type="button" className="cta cta--center sheet__cta" disabled={busy} onClick={add}>Add “{t}” as a new brand</button>}
    </Sheet>
  )
}
